import { render } from "./ViewComposition.vue?vue&type=template&id=67ba2e4b&scoped=true&ts=true"
import script from "./ViewComposition.vue?vue&type=script&lang=ts"
export * from "./ViewComposition.vue?vue&type=script&lang=ts"

import "./ViewComposition.vue?vue&type=style&index=0&id=67ba2e4b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ba2e4b"]])

export default __exports__